import axios from '@/utils/request';

export const getPcs = (groupNo) => axios.get("/blade-wems/device/group/pcs?groupNo=" + groupNo);

export const chartPcs = (deviceNo, type, beginCollectTime, endCollectTime) => axios.get("/blade-wems/datatagday/getTagData?deviceNo=" + deviceNo + "&type=" + type  + "&beginCollectTime=" + beginCollectTime + "&endCollectTime=" + endCollectTime);

export const pcsId = (pcsId) => axios.get("/blade-wems/pcs/getPcsData?pcsId=" + pcsId);

export const getCnPcsCuData = (pcsId) => axios.get("/blade-wems/pcs/getCnPcsCuData?pcsId=" + pcsId);

export const getCnPcsDuiData = (pcsId) => axios.get("/blade-wems/pcs/getCnPcsDuiData?pcsId=" + pcsId);

export const getCnPcsStatus = (pcsId) => axios.get("/blade-wems/pcs/getCnPcsStatus?pcsId=" + pcsId);

export const getCnPcsEnvData = (pcsId) => axios.get("/blade-wems/pcs/getCnPcsEnvData?pcsId=" + pcsId);

export const resetPCS = (no, pcsSn) => axios.post("/blade-wems/ems/pcsset", {no, pcsSn});

export const getPvPcs = (deviceNo) => axios.get("/blade-wems/pv/data?deviceNo=" + deviceNo);

export const getGfdata = (deviceNo) => axios.get("/blade-wems/pv/gfdata?deviceNo=" + deviceNo);

export const getPvTagData = (params) => axios.get("/blade-wems/datatagday/getTagData", { params });

export const getPvDevice = (groupNo) => axios.get("/blade-wems/device/group/pv?groupNo=" + groupNo);

